export const LoginForm = {
  Email: 'email',
  Code: 'code',
  SubmitBtn: 'submit-button',
  ResendCodeBtn: 'resend-code-btn',
}